import React, { useEffect, useState } from 'react';
import { Dropdown, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { exportEntryFile, getCategoryAll, getForm, getTemplateList } from '../../controller';
import { requestHandler } from '../../helper';
import DeleteModal from '../DeleteModal';
import Pagination from '../Pagination';
import SelectdownloadFormat from './SelectdownloadFormat';
import UserViewDetails from './UserViewDetails';
import formatDate from '../../helper/formatDate';
import { toast } from 'react-toastify';


function EntryForm() {
    const [entryFormData, setEntryFormData] = useState([]);
    let perPage = 10;
    const [page, setPage] = useState(1);
    const [paginationValue, setPaginationValue] = useState();
    const [searchQuery, setSearchQuery] = useState('');
    const [categoryId, setCategoryId] = useState("");
    const [templateId, setTemplateId] = useState("");
    const [categoryData, setCategoryData] = useState([]);
    const [tempData, setTempData] = useState([]);
    const [selectedCategoryName, setSelectedCategoryName] = useState('Category');
    const [selectedTemplateName, setSelectedTemplateName] = useState('Template');
    const getAllForms = async () => {
        await requestHandler(
            async () => await getForm(page, perPage, searchQuery, categoryId, templateId),
            null,
            (res) => {
                setEntryFormData(res.data.forms);
                setPage(res.data.page);
                setPaginationValue(res.data.paginationValue);
            },
            () => { }
        );
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            getAllForms();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
        // eslint-disable-next-line
    }, [searchQuery, page, perPage, categoryId, templateId]); //

    const getCategoryData = async () => {
        await requestHandler(
            async () => await getCategoryAll(true),
            null,
            (res) => {
                const { category } = res.data;
                setCategoryData(category);
            },
            () => { }
        );
    };

    useEffect(() => {
        getCategoryData();
    }, []); //

    const getTempData = async () => {
        await requestHandler(
            async () => await getTemplateList(),
            null,
            (res) => {
                setTempData(res.data.templates);
            },
            () => { }
        );
    };

    useEffect(() => {
        getTempData();
    }, []); //

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setPage(1); // Reset to the first page when search changes
    };

    const onSuccessData = () => {
        if (entryFormData.length === 1 && page > 1) {
            setPage(page - 1)
        } else {
            getAllForms(perPage, page, searchQuery, categoryId)
        }
    }



    const handleCategoryIdChange = (newValue) => {
        const selectedCategory = categoryData.find(category => category._id === newValue) || {}; // Find the selected category
        setSelectedCategoryName(selectedCategory.name || 'Category'); // Update selected category name
        setCategoryId(newValue === 'all' ? '' : newValue);
        setPage(1);
    };

    const handleTemplateIdChange = (newValue) => {
        // Set the new category ID and reset the page to 1
        const selectedTemplate = tempData.find(temp => temp._id === newValue) || {}; // Find the selected category
        setSelectedTemplateName(selectedTemplate.name || 'Template');
        setTemplateId(newValue === 'all' ? '' : newValue);
        setPage(1);
    };

    const handleDownload = async () => {
        try {
            const res = await exportEntryFile(); // Call the updated function
            const url = URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.download = `EntryFormManagement.xlsx`; // Set the file name and extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free up memory
            toast.success("Success! Your file has been downloaded");
        } catch (error) {
            console.error('Download error:', error);
            toast.error(error);
        }
    };

    return (
        <>
            <div className='overflow-auto-lg'>
                <div className="card-header border-0 p-0 pb-3">
                    <div className='row g-4'>
                        <div className="col-12 col-xl-4">
                            <div className='form-control search-bar py-0 px-0'>
                                <div className='search-box'>
                                    <img src="./images/png/seach-icon.png" width={13.81} height={13.81} alt="" />
                                </div>
                                <input type="text" className='form-control rounded-start-0 border-0' placeholder='Search here' value={searchQuery} onChange={handleSearchChange} />
                            </div>
                        </div>

                        <div className="col-12 col-xl-8">
                            <div className='d-flex flex-wrap justify-content-end align-items-center gap-3'>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle variant="success" id="dropdown-basic" className={selectedCategoryName !== 'Category' ? '' : 'text_light'}>

                                        {selectedCategoryName === 'all' ? 'Category' : selectedCategoryName}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleCategoryIdChange('all')} className={categoryId === '' ? 'selected-status' : ''}>All</Dropdown.Item>
                                        {categoryData.map((category, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => {
                                                    handleCategoryIdChange(category._id);
                                                }}
                                                className={categoryId === category._id ? 'selected-status' : ''}
                                            >
                                                {category.name}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle variant="success" id="dropdown-basic" className={selectedTemplateName !== 'Template' ? '' : 'text_light'}>
                                        {selectedTemplateName}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleTemplateIdChange('all')} className={templateId === '' ? 'selected-status' : ''}>All</Dropdown.Item>
                                        {tempData.map((temp, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => {
                                                    handleTemplateIdChange(temp._id); // Assuming category.id is available
                                                }}
                                                className={templateId === temp._id ? 'selected-status' : ''}
                                            >
                                                {temp.name}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>

                                <Link
                                    to={{
                                        pathname: '/entry-form-add',
                                    }}
                                    state={{
                                        categoryData: categoryData,
                                        tempData: tempData

                                    }}
                                    className='add-link'
                                >
                                    <img src="../images/png/plush.png" width={12} height={12} alt="" />
                                    <p className='m-0'>Add</p>
                                </Link>
                                <button className='add-btn' onClick={() => handleDownload()}>
                                    <p className='m-0'>Export file</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>

                                No
                            </th>
                            <th>
                                Company Name
                            </th>
                            <th>Company Motto </th>
                            <th>
                                Created At
                            </th>
                            <th>
                                Last Updated At
                            </th>
                            {/* <th style={{ width: "100px", }} className='text-center'>Logo</th>
                            <th style={{ width: "200px", }} className='text-center'>Watermark</th> */}
                            <th>Category </th>
                            <th>Template </th>
                            <th className='text-center'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Map through data to render table rows */}
                        {entryFormData.length > 0 ? (
                            entryFormData.map((item, index) => (
                                <tr key={index}>
                                    <td>{(page - 1) * perPage + index + 1}.</td>
                                    <td>{item?.companyName
                                    }</td>
                                    <td>{item?.companyMotto
                                    }</td>

                                    <td>{formatDate(item?.createdAt)}</td>
                                    <td>{formatDate(item?.updatedAt
                                    )}</td>

                                    <td>{item?.categoryId?.name || '-'}</td>
                                    <td>{item?.templateId?.name || '-'}</td>
                                    <td style={{ width: '180px', }} >
                                        <div className='d-flex justify-content-center align-items-center gap-2 actions-image'>
                                            <UserViewDetails formData={item} />
                                            <OverlayTrigger
                                                key="tooltip"
                                                placement="top"
                                                overlay={<Tooltip id={`tooltip-top`}>Edit</Tooltip>}
                                            >
                                                <Link to='/entry-form-edit' className='border-0'
                                                    state={{
                                                        data: item,
                                                        categoryData: categoryData,
                                                        templateData: tempData
                                                    }}
                                                >
                                                    <img src="../images/png/edit2.png" alt="" />
                                                </Link>
                                            </OverlayTrigger>

                                            <SelectdownloadFormat formId={item._id} />
                                            <DeleteModal title={"Form Details"} id={item._id} endPoint={`/forms/delete-form`} onSuccess={onSuccessData} />
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={8} className='text-center py-3'>
                                    No data available
                                </td>
                            </tr>
                        )}

                    </tbody>
                </Table>
                <div className='d-flex justify-content-center mt-4'>
                    {paginationValue > 1 && (
                        <Pagination
                            currentPage={page}
                            totalPages={paginationValue}
                            onPageChange={(newPage) => {
                                setPage(newPage);
                            }} />
                    )}
                </div>
            </div>
        </>
    )
}

export default EntryForm